import { useEffect } from 'react'

interface ShortcutHandler {
  key: string
  ctrl?: boolean
  shift?: boolean
  alt?: boolean
  meta?: boolean
  handler: () => void
  preventDefault?: boolean
}

export function useKeyboardShortcuts(shortcuts: ShortcutHandler[]) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      for (const shortcut of shortcuts) {
        const isCtrlMatch = shortcut.ctrl === undefined || shortcut.ctrl === event.ctrlKey
        const isShiftMatch = shortcut.shift === undefined || shortcut.shift === event.shiftKey
        const isAltMatch = shortcut.alt === undefined || shortcut.alt === event.altKey
        const isMetaMatch = shortcut.meta === undefined || shortcut.meta === event.metaKey
        const isKeyMatch = event.key.toLowerCase() === shortcut.key.toLowerCase()

        if (isKeyMatch && isCtrlMatch && isShiftMatch && isAltMatch && isMetaMatch) {
          if (shortcut.preventDefault !== false) {
            event.preventDefault()
          }
          shortcut.handler()
          break
        }
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [shortcuts])
} 